export const projects = [
  {
    title: "Changeling Website",
    subtitle: "Javascript, PHP, and MySQL",
    description:
      "This project was for my second internship at RIT. I joined the team in summer of 2022, and became team lead, overseeing 3 other web developers.This was the first project where I joined an in progress project, and it was certainly a new experience to say the least. It was a baptism of fire to say the least, as it showed me how important documentation is. My main task ended up being revamping the database for the team page. The database was a JSON file and was easily accessible, so I used MySQL and PHP to create a more secure database, with user profiles, password encryption, and then had to work with the current team page to properly display all the pertinent details.",
    image: "./project-1.png",
    link: "https://www.changelingvr.com/",
  },
  {
    title: "RIT Bus Tracker",
    subtitle: "HTML, CSS, and JavaScript",
    description:
      "My task was to create a website that used 2 different APIs to make a service/experience that functioned well, while also using Vue to display results. My partner and I made an RIT bus stop tracker, where the user is able to select a stop and see when the next bus arrives and what the name of that bus is. The APIs that we used were Mapbox and Transloc.Mapbox allowed us to use a map and put pins on that map that provided information. The Transloc API gave us all the bus times, names,and other data that we then displayed on the pings.",
    image: "./project-2.png",
    link: "https://people.rit.edu/app2076/330/Project2/",
  },
  {
    title: "Unix Webcamp",
    subtitle: "Javascript, PHP and MySQL",
    description:
      "I was the team lead for a small team where our task was to make a small page consisting of UNIX tutorials and quizzes. I wrote the quiz system that would record answers, and would provide feedback depending on if the answer was right or wrong.",
    image: "./project-3.png",
    link: "https://github.com/altonapecore/ISTE240Project.git",
  },
  {
    title: "Tree Squid",
    subtitle: "Unity",
    description:
      "This was a group project in which we had to make a game that fits within the Ethshard universe, so we took this funny creature and made a fun 3d puzzle game. The player plays as a squid and they launch themselves around various rooms, obstacles, and guards to collect a scroll. After you collect the scroll, the level is affected in some way and you now have to traverse this new level back to the beginning. The levels that I made were medievel themed, with cave and castle interiors.",
    image: "./project-4.png",
    link: "https://drive.google.com/file/d/1oQyQq7ZID84WabZ5-FqG2u9y4uvcjynF/view?usp=sharing",
  },
];

export const skills = [
  "JavaScript",
  "React",
  "MySQL",
  "HTML and CSS",
  "Unity",
  "C++",
];



// WEBPACK FOOTER //
// ./src/data.js